<section class="mt-4 card card-body bg-white border-0 shadow-sm">
  <h3 class="h4">
    {{ certificate.description }}
    @if (certificate.restrictedApprovedArea) {
      <span class="ms-2">(Subject Area - {{ certificate.restrictedApprovedArea }})</span>
    }
  </h3>
  <div class="row">
    <div class="col">
      <span class="small">Issue Date</span>
      <p class="lead">{{ certificate.startDate | date: 'MM/yyyy' }}</p>
    </div>
    <div class="col">
      <span class="small">Expiration Date</span>
      <p class="lead">{{ certificate.expirationDate | date: 'MM/yyyy' }}</p>
    </div>
    <div class="col">
      <span class="small">Status</span>
      @switch (certificate.statusCode.code) {
        @case (certificateStatusCodes.Valid) {
          <p class="lead"><span class="badge rounded-pill text-bg-success">Valid</span></p>
        }
        @case (certificateStatusCodes.Expired) {
          <p class="lead"><span class="badge rounded-pill text-bg-danger">Expired</span></p>
        }
        @case (certificateStatusCodes.Lapsed) {
          <p class="lead"><span class="badge rounded-pill text-bg-warning">Lapsed</span></p>
        }
        @case (certificateStatusCodes.SuspendedNonDisciplinary) {
          <p class="lead"><span class="badge rounded-pill text-bg-info">Suspended (Non-Disciplinary)</span></p>
        }
        @case (certificateStatusCodes.Revoked) {
          <p class="lead"><span class="badge rounded-pill text-bg-dark">Revoked</span></p>
        }
        @case (certificateStatusCodes.Surrendered) {
          <p class="lead"><span class="badge rounded-pill text-bg-primary">Surrendered</span></p>
        }
        @case (certificateStatusCodes.Suspended) {
          <p class="lead"><span class="badge rounded-pill text-bg-danger">Suspended</span></p>
        }
        @case (certificateStatusCodes.NotActive) {
          <p class="lead"><span class="badge rounded-pill text-bg-secondary">Not Active</span></p>
        }
        @default {
          <span class="badge badge-lg badge-danger me-2">Unknown Status</span>
        }
      }
    </div>
  </div>
  @if (certificate.allowableDeficiencies.length) {
    <div class="row">
      <div class="table-responsive mt-1">
        <table class="table">
          <thead>
            <tr>
              <th class="col" scope="col">Allowable Deficiency</th>
              <th class="col" scope="col">Issue Date</th>
              <th class="col" scope="col">End Date</th>
            </tr>
          </thead>
          <tbody>
            @for (allowableDeficiency of certificate.allowableDeficiencies; track certificate.personCertificateId) {
              <tr class="area-row">
                <td class="col">{{ allowableDeficiency.description }}</td>
                <td class="col">{{ allowableDeficiency.startDate | date: 'MM/dd/yyyy' }}</td>
                <td class="col">{{ allowableDeficiency.endDate | date: 'MM/dd/yyyy' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</section>
